import en from "./en"; // 英语
import cn from "./cn"; // 中文
export default {
  en: en,
  cn: cn
};